<template>
    <div class="input-component">
        <div v-if="editMode">
            <el-row :gutter="5">
                <el-col :sm="20" :md="20" :lg="22" :xl="22">
                    <div v-if="view.ValueType === 'Int32' || view.ValueType === 'Decimal'">
                        <el-input-number
                                v-model="value2"
                                v-on:keyup.enter="save()"
                                :placeholder="view.DisplayName"
                        ></el-input-number>
                    </div>
                    <div v-else-if="view.ValueType === 'String'">
                        <el-input
                                :type="value2.length > 100 ? 'textarea' : 'string'"
                                rows="10"
                                v-model="value2"
                                v-on:keyup.enter="save()"
                                :placeholder="view.DisplayName"
                        ></el-input>
                    </div>
                    <div v-else-if="view.ValueType === 'Tariff'">
                        <el-select :clearable="true" v-model="value2" @change="setTarif" placeholder="Выберите тариф" class="w-100">
                            <el-option
                                    v-for="item in $tarifDict"
                                    :key="item.ID"
                                    :label="item.Name"
                                    :multiple="false"
                                    :value="item.ID">
                            </el-option>
                        </el-select>
                    </div>
                    <div v-else-if="view.ValueType === 'CustomerGroup'">
                        <el-select :clearable="true" v-model="value2" @change="setCustomerGroup" placeholder="Укажите группу клиента" class="w-100">
                            <el-option
                                    v-for="item in $customerGroupDict"
                                    :key="item.ID"
                                    :label="item.Name"
                                    :multiple="false"
                                    :value="item.ID">
                            </el-option>
                        </el-select>
                    </div>
                    <div v-else-if="view.ValueType === 'Zone'">
                        <el-select :clearable="true" v-model="value2" @change="setZone" placeholder="Укажите зону" class="w-100">
                            <el-option
                                    v-for="item in $zonesDict"
                                    :key="item.ID"
                                    :label="item.Name"
                                    :multiple="false"
                                    :value="item.ID">
                            </el-option>
                        </el-select>
                    </div>
                    <div v-else-if="view.ValueType === 'DateTime'">
                        <el-date-picker
                                class="w-100"
                                v-model="value2"
                                type="datetime"
                                :placeholder="view.DisplayName"
                        >
                        </el-date-picker>
                    </div>
                    <div v-else-if="view.ValueType === 'Color'">
                        <el-color-picker @change="save()" v-model="value2"></el-color-picker>
                    </div>
                    <div v-else>
                        <el-input v-model="value2" v-on:keyup.enter="save()" :placeholder="view.DisplayName"></el-input>
                    </div>
                </el-col>
                <el-col :sm="4" :md="4" :lg="2" :xl="2" v-if="view.ValueType !== 'CustomerGroup' && view.ValueType !== 'Tariff' && view.ValueType !== 'Color'">
                    <el-button class="check" type="primary" size="mini" @click="save()" icon="icon-check"></el-button>
                </el-col>
            </el-row>
        </div>
        <div v-else>
            <div v-if="companyId !== 4 && companyId !== 5" @click="edit()" :class="(view.Enabled ? 'editable' : '')">
                {{value2text || value2 || 'не задано'}}
            </div>
            <div v-else>
                {{value2text || value2 || 'не задано'}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['value', 'view', 'itemType'],
        data () {
            return {
                companyId: null,
                editMode: false,
                value2: this.value,
                value2text: '',
                boolDict: [
                    {
                        0: "Разрешено",
                        1: "Не разрешено"
                    },
                    {
                        0: "Заблокирована",
                        1: "Не заблокирована"
                    },
                    {
                        0: "Контролируется",
                        1: "Не контролируется"
                    },
                    {
                        0: "Да",
                        1: "Нет"
                    }
                ]
            }
        },
        methods: {
            edit () {
                if (!this.view.Enabled) return

                if (this.view.ValueType === 'Boolean') {
                    let bkey = false

                    if (this.value2 == "Не разрешено") { this.value2 = "Разрешено"; bkey = true; }
                    else if (this.value2 == "Разрешено") { this.value2 = "Не разрешено"; bkey = false; }

                    if (this.value2 == "Не заблокирована") { this.value2 = "Заблокирована"; bkey = true; }
                    else if (this.value2 == "Заблокирована") { this.value2 = "Не заблокирована"; bkey = false; }

                    if (this.value2 == "Не контролируется") { this.value2 = "Контролируется"; bkey = true; }
                    else if (this.value2 == "Контролируется") { this.value2 = "Не контролируется"; bkey = false; }

                    if (this.value2 == "Нет") { this.value2 = "Да"; bkey = true; }
                    else if (this.value2 == "Да") { this.value2 = "Нет"; bkey = false; }

                    if (this.value2 == "Не занимает") { this.value2 = "Занимает"; bkey = true; }
                    else if (this.value2 == "Занимает") { this.value2 = "Не занимает"; bkey = false; }

                    if (this.value2 == "Не зафиксирован") { this.value2 = "Зафиксирован"; bkey = true; }
                    else if (this.value2 == "Зафиксирован") { this.value2 = "Не зафиксирован"; bkey = false; }

                    this.save(bkey)
                }
                else {
                    this.editMode = true
                }
            },
            setTarif () {
                this.value2text = this.$tarifDict.find(x => x.ID === this.value2).Name
                this.save()
            },
            setCustomerGroup () {
                this.value2text = this.$customerGroupDict.find(x => x.ID === this.value2).Name
                this.save()
            },
            setZone () {
                this.value2text = this.$zonesDict.find(x => x.ID === this.value2).Name
                this.save()
            },
            save (val) {

                console.log('Save', val, this.value2)
                let request = {
                    Id: "SetProperty",
                    Name: "SetItemProperty",
                    ItemType: this.itemType,
                    ItemId: this.$route.params.id,
                    ItemPropertyName: this.view.Name,
                    ItemPropertyValue: (typeof val !== 'undefined' ? val : this.value2)
                }
                console.log(request)

                this.$api.Main.setProperty(request).then(response => {
                    console.log(response)

                    if (response.Result === "Success") {
                        this.$message({
                            message: 'Сохранили значение',
                            type: 'success',
                            res: response
                        })

                        if (this.view.ValueType !== 'Color') {
                            this.editMode = false
                        }
                    }
                    else {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error',
                            res: response
                        })
                    }
                }).catch (err => {
                    console.log(err)
                })
            },
            toHex (c) {
                let hex = c.toString(16)
                return hex.length === 1 ? '0' + hex : hex
            },
            rgb2hex (r, g, b) {
                return '#' + this.toHex(r) + this.toHex(g) + this.toHex(b)
            }
        },
        created () {
            // TODO: костыль для личного кабинета!
            this.companyId = this.$loginType()

            // set ID instead of value
            if (this.view.ValueType === 'Tariff') {
                this.value2text = this.value2
                if (this.$tarifDict.find(x => x.Name === this.value2)) {
                    this.value2 = this.$tarifDict.find(x => x.Name === this.value2).ID
                }
                else {
                    this.value2 = ''
                }
            }
            if (this.view.ValueType === 'CustomerGroup') {
                this.value2text = this.value2
                if (this.$customerGroupDict.find(x => x.Name === this.value2)) {
                    this.value2 = this.$customerGroupDict.find(x => x.Name === this.value2).ID
                }
                else {
                    this.value2 = ''
                }
            }
            if (this.view.ValueType === 'Zone') {
                this.value2text = this.value2
                if (this.$zonesDict.find(x => x.Name === this.value2)) {
                    this.value2 = this.$zonesDict.find(x => x.Name === this.value2).ID
                }
                else {
                    this.value2 = ''
                }
            }
            if (this.view.ValueType === 'Color') {
                let color = this.value2.split('; ')
                this.value2 = this.rgb2hex(parseInt(color[0], 10), parseInt(color[1], 10), parseInt(color[2], 10))

                this.editMode = true
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
